import { apiRequest } from "@services/apiClient";

// List the Sikka offices our account is authorized to access (for admin matching).
export const fetchSikkaAuthorizedPractices = async () => {
  return apiRequest({
    method: "GET",
    endpoint: "/scheduling/sikka/authorized_practices",
  });
};

// Match a backend clinic to a Sikka office: persists config + runs setup (pulls
// patients/providers). Returns the setup summary counts in `data`.
export const matchClinicToSikka = async (clinicId, officeId) => {
  return apiRequest({
    method: "POST",
    endpoint: `/scheduling/sikka/match/${clinicId}`,
    body: { office_id: officeId },
  });
};

